export interface IAttachmentsState {
  current: IAttachments;
  list: Array<IAttachments>;
}

export interface IAttachments {
  id: any;
  name?: string;
  file_type?: string;
  file_byte?: string;
  source?: string;
  title_audio?: boolean;
  avatar?: boolean;
}

export const ATTACHMENTS_STATE = {
  current: null,
  list: []
};

export class Attachments implements IAttachments {
  id: any;
  name?: string;
  file_type?: string;
  file_byte?: string;
  source?: string;
  title_audio?: boolean;
  avatar?: boolean;

    constructor(obj: IAttachments = {} as IAttachments) {
        const {
          id = null,
          name = '',
          file_type = '',
          file_byte = '',
          source = '',
          title_audio = false,
          avatar = false
        } = obj;

        this.id = id,
        this.name = name,
        this.file_type = file_type,
        this.file_byte = file_byte,
        this.source = source,
        this.title_audio = title_audio;
        this.avatar = avatar;
    }

    static from(obj): IAttachments {
      return new Attachments({
        id : obj.idattachment,
        name : obj.name,
        file_type : obj.file_type,
        file_byte : obj.file_byte,
        source : obj.source,
        title_audio : obj.title_audio,
        avatar : obj.avatar
      });
  }
  static fromArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(Attachments.from).filter(item => item != null);
  }

  static to(obj) {
    return {
      idattachment : obj.id,
      name : obj.name,
      file_type : obj.file_type,
      file_byte : obj.file_byte,
      source : obj.source,
      title_audio : obj.title_audio,
      avatar : obj.avatar
    };
  }
  static toArray(list) {
    if (!list || !(list instanceof Array)) {
        return [];
    }
    return list.map(Attachments.to).filter(item => item != null);
  }
}
